import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";

import { useAxios } from "../../../hooks";
import List from "../campaign list components/List";
import { Pagination } from "../../../components";
import SubNavbar from "../../../components/SubNavbar";
import { CreateButton } from "../../css components/Button";
import { getAllCampaigns } from "../create campaign components/campaign form components/campaignObject";
import pages from "../../../constants/pages";

export default function Campaign() {
  const axios = useAxios();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [page, setPage] = useState({ page: 1, totalCount: 0, lastCount: 0 });

  const { activeBrand } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    setLoading(true);
    let url =
      "/user/brand/getCampaignsByBrand/?brandId=" +
      activeBrand.ID +
      `&page=${page.page}&limit=10` +
      (searchKey ? `&search=${encodeURIComponent(searchKey)}` : "");

    axios({
      url: url,
    }).then((response) => {
      if (response.status) {
        setCampaigns(getAllCampaigns(response, activeBrand));

        setPage((prev) => ({
          ...prev,
          totalCount: response.data.totalCounts,
          lastPage: response.data.campaignData.length < 10,
        }));
      }
      setLoading(false);
    });
  }, [axios, activeBrand.ID, activeBrand, searchKey, page.page]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  return (
    <Fragment>
      <SubNavbar
        pageName={"Campaigns"}
        buttons={[
          <CreateButton
            variant="contained"
            onClick={() => navigate(pages.createCampaign.route)}
          >
            Create Campaign
          </CreateButton>,
        ]}
      />

      <List
        loading={loading}
        setPage={setPage}
        setSearchKey={setSearchKey}
        campaigns={campaigns}
        component=""
      />

      {!!page.totalCount && (
        <Grid item container display={"flex"} justifyContent={"center"}>
          <Pagination
            style={{ marginTop: "20px" }}
            count={Math.ceil(page.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
